import React from 'react';

import { Type } from '@spotify-internal/encore-creator-web';
import { gray50 } from '@spotify-internal/encore-foundation';

import { musicReliefOrgsUrl } from '../../lib/constants';

import { Heading3, TextLinkUnderlined } from '../StyleElements';

type Props = { isEditing?: boolean };

export function Headings(props: Props) {
  const headingCopy = props.isEditing
    ? 'Edit your Artist Fundraising Pick'
    : 'Set your Artist Fundraising Pick';

  return (
    <>
      <Heading3>{headingCopy}</Heading3>

      <Type
        as="p"
        variant={Type.body2}
        color={gray50}
        style={{
          paddingBottom: '40px',
          fontSize: '16px',
          lineHeight: '24px',
        }}
      >
        You can add a personal link, a COVID-19 cause, or choose one of the{' '}
        <TextLinkUnderlined href={musicReliefOrgsUrl} target="orgs">
          Music Relief organizations
        </TextLinkUnderlined>
        .
      </Type>
    </>
  );
}
